import { gql } from 'graphql-tag';
import moment from 'moment';
import { useContext } from 'react';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

export const GET_TRACK_EXPIRED_CREDITS = gql`
  query GetTrackExpiredCredits($creditsInput: GetTrackCreditsInput!) {
    getTrackExpiredCredits(input: $creditsInput) {
      count
      results {
        id
        formatted_name
      }
    }
  }
`;

export function useGetTrackExpiredCredits() {
  const { input: search } = useSearchInput();
  const {
    state: { accountId },
  } = useContext(AppContext);

  // Get year from URL params, default to current year
  const thisYear = Number(moment().format('YYYY'));
  const yearFilter = search.year ? Number(search.year) : thisYear;

  // Only include queryString from search params for GraphQL
  const queryString = search.queryString || '';

  // Get page number from URL (as string for this API)
  const page = search.page ? String(search.page) : '1';

  const result = usePersistedQuery(
    GET_TRACK_EXPIRED_CREDITS,
    `track-expired-credits`,
    {
      variables: {
        creditsInput: {
          queryString,
          year: yearFilter,
          account_id: accountId,
          page,
        },
      },
      fetchPolicy: 'cache-and-network',
    }
  );

  return { ...result, resExpired: result.data };
}
